import { render, staticRenderFns } from "./IconStore.vue?vue&type=template&id=243d133b&"
import script from "./IconStore.vue?vue&type=script&lang=ts&"
export * from "./IconStore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports